// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1UsbI","select":"Header_select__Ycg-f","clinic":"Header_clinic__3H3SG"};